import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { Box, Button } from '@material-ui/core';
import { useState } from 'react';
import Constant from '@/common/constant/Constant';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function RenderExportMenu({
    action,
    currentSearchParams,
    setIsOpenDialogConfirm,
    setIsShowExportMenu
}) {
    // Re-render when the translation dictionary loads/updates
    useTranslationSubscription();

    const [exportFileType, setExportFileType] = useState(Constant.BULK_ACTION_EXPORT_FILE_TYPE.CSV);
    const [hasExportChatThread, setHasExportChatThread] = useState(
        Constant.BULK_ACTION_EXPORT_CHAT_THREAD.OFF
    );

    const confirmExport = () => {
        setIsOpenDialogConfirm(preState => {
            return {
                ...preState,
                status: true,
                action: action,
                params: {
                    action: action,
                    searchCondition: JSON.stringify(currentSearchParams),
                    exportOptions: JSON.stringify({
                        exportType: exportFileType,
                        hasExportChatThread: hasExportChatThread
                    })
                }
            };
        });
    };

    const cancelExport = () => {
        setIsShowExportMenu(false);
        setIsOpenDialogConfirm({
            status: false,
            action: '',
            params: {}
        });
    };

    return (
        <>
            <FormControl component="fieldset" focused={false}>
                <Box px={'1.5rem'} pb={'0.1rem'} pt={'1rem'} borderTop={1} borderColor={'#E3E5E8'}>
                    <FormLabel component="legend">
                    <Typography variant="contained" className='font-family-common'>
                            {trI18n('EXPORT_FORMAT_LABEL')}
                        </Typography>
                    </FormLabel>
                    <RadioGroup
                        row
                        name="exportFileType"
                        value={exportFileType}
                        onChange={e => setExportFileType(e.target.value)}
                    >
                        <Box display={'flex'} justifyContent={'start'} width={'100%'}>
                            <Box width={'50%'}>
                                <FormControlLabel
                                    className="tag-item custom-radio"
                                    value={Constant.BULK_ACTION_EXPORT_FILE_TYPE.CSV}
                                    control={<Radio size="small" />}
                                    label="CSV"
                                />
                            </Box>
                            <Box width={'50%'}>
                                <FormControlLabel
                                    className="tag-item custom-radio"
                                    value={Constant.BULK_ACTION_EXPORT_FILE_TYPE.JSON}
                                    control={<Radio size="small" />}
                                    label="JSON"
                                />
                            </Box>
                        </Box>
                    </RadioGroup>
                </Box>
            </FormControl>
            <FormControl component="fieldset" focused={false}>
                <Box px={'1.5rem'} py={'0.1rem'}>
                    <FormLabel>
                    <Typography variant="contained" className='font-family-common'>
                            {trI18n('EXPORT_CHAT_THREAD_LABEL')}
                        </Typography>
                    </FormLabel>
                    <RadioGroup
                        row
                        name="hasExportChatThread"
                        value={hasExportChatThread}
                        onChange={e => setHasExportChatThread(e.target.value)}
                    >
                        <Box display={'flex'} justifyContent={'start'} width={'100%'}>
                            <Box width={'50%'}>
                                <FormControlLabel
                                    className="custom-radio"
                                    value={Constant.BULK_ACTION_EXPORT_CHAT_THREAD.OFF}
                                    control={<Radio size="small" />}
                                    label={trI18n('EXPORT_CHAT_THREAD_NOT_INCLUDE')}
                                />
                            </Box>
                            <Box width={'50%'}>
                                <FormControlLabel
                                    className="custom-radio"
                                    value={Constant.BULK_ACTION_EXPORT_CHAT_THREAD.ON}
                                    control={<Radio size="small" />}
                                    label={trI18n('EXPORT_CHAT_THREAD_INCLUDE')}
                                />
                            </Box>
                        </Box>
                    </RadioGroup>
                </Box>
            </FormControl>
            <Box display={'flex'} justifyContent={'end'} px={'2em'} py={'1rem'}>
                <Button
                    className="btn-cancel-share-public-range btn-hg32"
                    variant="outlined"
                    onClick={cancelExport}
                >
                    {trI18n('CM-BUTTON-CANCEL')}
                </Button>
                <Button
                    className="btn-send btn-primary btn-hg32"
                    variant="contained"
                    color="primary"
                    data-cy="btn-submit-add-ticket"
                    onClick={confirmExport}
                >
                    {trI18n('export_confirm')}
                </Button>
            </Box>
        </>
    );
}
